import { DatePicker } from "antd";
import momentGenerateConfig from "./config";
var MomentDatePicker = function () {
  // @ts-ignore for antd v4 need to import picker from 'antd/es/date-picker/generatePicker' (https://4x.ant.design/docs/react/replace-moment)
  if (typeof DatePicker.generatePicker === "function") {
    // @ts-ignore
    return DatePicker.generatePicker(momentGenerateConfig);
  } else {
    // support ant 4.x
    return DatePicker;
  }
}();
export default MomentDatePicker;